import {
  ConnectionPathTopRightAnimated,
  ConnectionPathTopLeftAnimated,
  ConnectionPathTopMiddleAnimated,
  ConnectionPathBottomRightAnimated,
  ConnectionPathBottomLeftAnimated,
} from '../embed/connection-lines'
import DatabaseGroup from '../product/database-group.svg?react'
import PlatformIllustration from '../embed/platform.svg?react'
import { ReactNode } from 'react'

type PlatformMarchitectureProps = {
  databaseLogo?: ReactNode
}
export const PlatformMarchitecture = ({
  databaseLogo,
}: PlatformMarchitectureProps) => (
  <div className="platform-marchitecture">
    <div className="usage-cards card-group">
      <div>Internal Analytics</div>
      <div>Operational Analytics</div>
      <div>Embedded Analytics</div>
    </div>

    <PlatformIllustration />
    <div className="workbook-cards card-group">
      <div>Workbook</div>
      <div>Workbook</div>
      <div>Workbook</div>
    </div>

    <div className="connections-top">
      <ConnectionPathTopLeftAnimated />
      <ConnectionPathTopMiddleAnimated />
      <ConnectionPathTopRightAnimated />
    </div>

    <div className="connections-bottom">
      <ConnectionPathBottomLeftAnimated />
      <ConnectionPathBottomRightAnimated />
    </div>

    <div className="shared-model-card card-group">
      <div>Shared Model</div>
    </div>

    <div className="schema-cards card-group">
      <div>Schema</div>
      <div>Materialized</div>
    </div>
    <div className="database-illustration">
      <DatabaseGroup />
      {databaseLogo && <div className="database-logo">{databaseLogo}</div>}
    </div>
  </div>
)
